import { useContext, useEffect, useState } from "react";
import { TokensContext } from "./TokensContext";
import { EmpresaApi } from "../../hooks/empresaApi";
import { AuthContext } from "../Auth/AuthContext";

export const TokensProvider = ({ children }: { children: JSX.Element }) => {
  const empresaApi = EmpresaApi();
  const { permissoesPlanos, user } = useContext(AuthContext);
  
  const [tokensDisponiveis, setTokensDisponiveis] = useState<number | null>(null);
  const [statusTokens, setStatusTokens] = useState<{ tokens_atuais: number; limite_tokens: number } | null>(null);
  const [jaCarregou, setJaCarregou] = useState(false);

  // Função para calcular tokens disponíveis baseado na regra
  const calcularTokensDisponiveis = (status: { tokens_atuais: number; limite_tokens: number }) => {
    if (status.tokens_atuais >= status.limite_tokens) {
      return 0;
    }
    return status.limite_tokens - status.tokens_atuais;
  };

  const atualizarTokens = async () => {
    try {
      const statusAtualizado = await empresaApi.getStatusTokensIA();
      setStatusTokens(statusAtualizado);
      const tokensCalculados = calcularTokensDisponiveis(statusAtualizado);
      setTokensDisponiveis(tokensCalculados);
      
    } catch (error) {
      console.error("Erro ao atualizar status dos tokens:", error);
      setTokensDisponiveis(0);
      setStatusTokens({ tokens_atuais: 0, limite_tokens: 0 });
    }
  };

  const decrementarTokens = (quantidade: number) => {
    if (statusTokens) {
      const novoStatus = {
        ...statusTokens,
        tokens_atuais: statusTokens.tokens_atuais + quantidade
      };
      
      setStatusTokens(novoStatus);
      const tokensCalculados = calcularTokensDisponiveis(novoStatus);
      setTokensDisponiveis(tokensCalculados);
    }
  };

  // Função para estimar tokens necessários baseado na presença de imagem
  const estimarTokensNecessarios = (temImagem: boolean) => {
    return temImagem ? 1300 : 400; // Com imagem: 1300 tokens, sem imagem: 400 tokens
  };

  // Função para validar se há tokens suficientes
  const validarTokensSuficientes = (temImagem: boolean) => {
    const tokensNecessarios = estimarTokensNecessarios(temImagem);
    const tokensAtualmenteDisponiveis = tokensDisponiveis || 0;
    
    return {
      suficiente: tokensAtualmenteDisponiveis >= tokensNecessarios,
      tokensNecessarios,
      tokensDisponiveis: tokensAtualmenteDisponiveis
    };
  };

  useEffect(() => {
    const carregarTokens = async () => {
      if (!permissoesPlanos || jaCarregou) return;
      
      try {
        const statusAtualizado = await empresaApi.getStatusTokensIA();        
        setStatusTokens(statusAtualizado);
        const tokensCalculados = calcularTokensDisponiveis(statusAtualizado);
        setTokensDisponiveis(tokensCalculados);
        setJaCarregou(true);
        
      } catch (error) {
        console.error("Erro ao carregar status dos tokens:", error);
        setTokensDisponiveis(0);
        setStatusTokens({ tokens_atuais: 0, limite_tokens: 0 });
      }
    };

    carregarTokens();
  }, [permissoesPlanos]);

   useEffect(() => {
    if (user) {
      atualizarTokens();
    }
  }, [user]);

  return (
    <TokensContext.Provider value={{
      tokensDisponiveis,
      statusTokens,
      atualizarTokens,
      decrementarTokens,
      calcularTokensDisponiveis,
      estimarTokensNecessarios,
      validarTokensSuficientes
    }}>
      {children}
    </TokensContext.Provider>
  );
};
